/* Merchant-approved $0-copy promotion. Client-side reconciliation only, NOT
 * server-side purchase enforcement. Gift-only bypass orders are manually reviewed.
 * Existing discount codes/attributes and paid line quantities are never changed. */
(function () {
  function plan(cart, gifts, preferred, threshold = 15000, currency = 'USD') {
    const ids = new Set(gifts.map(g => String(g.variantId)));
    const lines = (cart.items || []).filter(i => ids.has(String(i.variant_id || i.id)));
    const spend = Math.max(0, Number(cart.total_price) - lines.reduce((n, i) => n + Number(i.final_line_price || 0), 0));
    const eligible = cart.currency === currency && spend >= threshold;
    const choices = gifts.filter(g => g.available !== false);
    const existing = choices.find(g => lines.some(i => String(i.variant_id || i.id) === String(g.variantId)));
    const selected = eligible ? choices.find(g => String(g.variantId) === String(preferred)) || existing || choices[0] : null;
    const updates = {};
    let kept = false;
    for (const line of lines) {
      const keep = selected && !kept && String(line.variant_id || line.id) === String(selected.variantId) && Number(line.final_line_price) === 0;
      if (keep) kept = true;
      const quantity = keep ? 1 : 0;
      if (line.quantity !== quantity) updates[line.key] = quantity;
    }
    return {spend, eligible, selected, updates, add: selected && !kept ? selected.variantId : null};
  }
  if (typeof module === 'object' && module.exports) { module.exports = {plan}; return; }
  if (window.SakuraCartGift) return;
  const configNode = document.getElementById('sakura-free-gift-config');
  if (!configNode) return;
  const cfg = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const threshold = cfg.threshold || 15000;
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:cfg.currency}).format(cents / 100);
  const esc = s => String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let cart, preferred, selecting, timer, running, dirty = false, error = '', availabilityAt = 0;
  const gifts = cfg.gifts;
  const widgets = () => document.querySelectorAll('sakura-free-gift');
  const convert = () => { try { window.bucksCC?.reConvert?.(); } catch (_) {} };
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {cache:'no-store',headers:{Accept:'application/json'}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Please refresh your bag to check your free gift.');
    return data;
  }
  // Source items remain the authority for availability; the zero-price copies
  // intentionally do not pretend to share inventory or supplier mappings.
  async function availability() {
    if (Date.now() - availabilityAt < 60000) return;
    await Promise.all(gifts.map(async g => {
      try {
        const [source, copy] = await Promise.all([request(`products/${g.sourceHandle}.js`),request(`products/${g.handle}.js`)]);
        const s = source.variants.find(v => String(v.id) === String(g.sourceVariantId));
        const v = copy.variants.find(v => String(v.id) === String(g.variantId));
        g.available = !!s?.available && !!v?.available && Number(v.price) === 0;
        g.images = source.images?.length ? source.images : [g.image];
      } catch (_) { g.available = false; }
    }));
    availabilityAt = Date.now();
  }
  function draw() {
    if (!cart) return;
    const p = plan(cart,gifts,preferred,threshold,cfg.currency);
    const paidCount=cart.items.reduce((n,i)=>n+(gifts.some(g=>String(g.variantId)===String(i.variant_id||i.id))?0:i.quantity),0);
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span').forEach(span=>{span.textContent=span.textContent.replace(/\d+/,String(paidCount));});
    for (const widget of widgets()) {
      widget.hidden = !cart.items.some(i => !gifts.some(g => String(g.variantId) === String(i.variant_id || i.id)));
      widget.querySelector('[data-gift-progress]').style.width = Math.min(100,p.spend / threshold * 100) + '%';
      widget.querySelector('[data-gift-progressbar]').setAttribute('aria-valuenow',String(Math.min(threshold,p.spend)));
      const signature = `${p.spend}:${cart.currency}:${p.eligible}:${p.selected?.variantId}:${gifts.map(g=>g.available).join(',')}:${error}:${selecting}`;
      if (widget.dataset.state !== signature) {
        widget.dataset.state = signature;
        widget.querySelector('[data-gift-current]').innerHTML = `<span class="money">${money(p.spend)}</span>`;
        widget.querySelector('[data-gift-status]').innerHTML = selecting ? 'Updating your complimentary gift…' : error ? esc(error) : p.eligible && p.selected
          ? 'Your complimentary gift is included. Swap your gift below.'
          : p.eligible ? 'Complimentary gifts are currently unavailable.'
          : `Add <span class="money">${money(Math.max(0,threshold-p.spend))}</span> more to unlock your free gift.`;
        widget.querySelectorAll('[data-gift-choice]').forEach(button => {
          const gift = gifts.find(g => String(g.variantId) === button.dataset.giftChoice);
          const included = p.selected && String(p.selected.variantId) === button.dataset.giftChoice && cart.items.some(i=>String(i.variant_id||i.id)===button.dataset.giftChoice);
          const pending=String(selecting)===button.dataset.giftChoice;
          button.disabled = !!selecting || !p.eligible || !gift.available;
          button.dataset.locked = String(!p.eligible || !gift.available);
          button.setAttribute('aria-pressed',String(selecting?pending:!!included));
          button.querySelector('[data-gift-caption]').textContent = pending ? 'SELECTING…' : !gift.available ? 'UNAVAILABLE' : included ? 'INCLUDED ✓' : p.eligible ? 'SELECT GIFT' : 'FREE GIFT';
        });
        convert();
      }
      widget.setAttribute('aria-busy',String(!!running));
    }
  }
  function refresh(data) {
    // Gift-only mutations do not change paid prices. Keep the existing drawer,
    // images, scroll and focus intact. Dawn's positional controls must still be
    // reindexed when a gift line ahead of a paid line is removed.
    document.querySelectorAll('tr[data-cart-line-key]').forEach(row=>{
      const index=data.items.findIndex(item=>item.key===row.dataset.cartLineKey);
      if(index<0)return;
      const old=row.id.match(/-(\d+)$/)?.[1], next=String(index+1);
      if(!old||old===next)return;
      [row,...row.querySelectorAll('*')].forEach(node=>{
        for(const attr of ['id','for','aria-describedby']){
          const value=node.getAttribute(attr);
          if(value)node.setAttribute(attr,value.replace(new RegExp('-'+old+'(?=\\s|$)','g'),'-'+next));
        }
        if(node.hasAttribute('data-index'))node.dataset.index=next;
      });
    });
    document.dispatchEvent(new CustomEvent('sakura:gift-reconciled',{detail:{cart:data}}));
  }
  async function reconcile() {
    if (running) { dirty = true; return running; }
    clearTimeout(timer); dirty = false;
    running = (async()=>{
      try {
        const [,current]=await Promise.all([availability(),request('cart.js')]);
        cart = current;
        let p = plan(cart,gifts,preferred,threshold,cfg.currency);
        // Remove old gift and add the chosen zero-price variant in ONE update.
        // update.js returns the complete cart, eliminating add + reread round trips.
        // No paid quantities, discounts or attributes are included in the payload.
        const updates={...p.updates};
        if(p.add)updates[String(p.add)]=1;
        if (Object.keys(updates).length) {
          cart = await request('cart/update.js',{updates});
          refresh(cart);
          // Recheck the returned total: another tab may have reduced paid items.
          const followup = plan(cart,gifts,preferred,threshold,cfg.currency);
          if(Object.keys(followup.updates).length)cart=await request('cart/update.js',{updates:followup.updates});
          refresh(cart);
        }
        error = '';
      } catch (_) {
        // No blind repeat of an ambiguous add. A subsequent cart read determines
        // whether it succeeded before any further mutation.
        error='Please refresh your bag to check your free gift.';
      } finally { running = null; draw(); }
    })();
    await running;
    if (dirty) schedule();
  }
  function schedule() { dirty=true; clearTimeout(timer); timer=setTimeout(reconcile,450); }
  async function chooseGift(id){
    if(selecting)return;
    preferred=id;selecting=id;error='';draw(); // Immediate feedback before network.
    try{if(running)await running;await reconcile();}
    finally{selecting=null;draw();}
  }
  function openGift(gift) {
    if(!cart||!window.SakuraCartPreview)return;
    const state=()=>{
      const p=plan(cart,gifts,preferred,threshold,cfg.currency);
      const included=cart.items.some(i=>String(i.variant_id||i.id)===String(gift.variantId));
      return {label:included?'GIFT INCLUDED':!gift.available?'UNAVAILABLE':p.eligible?'SELECT THIS GIFT':'UNLOCK WITH YOUR ORDER',disabled:included||!p.eligible||!gift.available};
    };
    window.SakuraCartPreview.openGift({title:gift.title,images:gift.images||[gift.image],url:root+'products/'+gift.sourceHandle,...state(),status:'One complimentary gift on qualifying orders.',select:async()=>{
      await chooseGift(gift.variantId);
      if(error)throw new Error(error);
      return state();
    }});
  }
  class GiftWidget extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-gift-progress]')) {
        this.innerHTML=`<div class="sk-gift__goal"><h3><strong>FREE GIFT</strong> ON ORDERS <span class="money">${money(threshold)}</span>+</h3><div class="sk-gift__bar" data-gift-progressbar role="progressbar" aria-label="Progress towards your free gift" aria-valuemin="0" aria-valuemax="${threshold}"><span data-gift-progress></span></div><div class="sk-gift__amounts"><span data-gift-current></span><span class="money">${money(threshold)}</span></div><p data-gift-status aria-live="polite"></p></div><div class="sk-gift__choices">${gifts.map(g=>`<div class="sk-gift__card"><button type="button" data-gift-choice="${g.variantId}" disabled aria-pressed="false"><img src="${esc(g.image)}" alt="${esc(g.title)}" loading="lazy" width="240" height="200"><strong>${esc(g.title)}</strong><small data-gift-caption>FREE GIFT</small></button><button type="button" class="sk-gift__preview" data-gift-preview="${g.variantId}" aria-label="Preview ${esc(g.title)}">+</button></div>`).join('')}</div>`;
        this.addEventListener('click',e=>{
          const preview=e.target.closest('[data-gift-preview]');
          if(preview){e.preventDefault();openGift(gifts.find(g=>String(g.variantId)===preview.dataset.giftPreview));return;}
          const b=e.target.closest('[data-gift-choice]');if(!b||b.disabled)return;
          e.preventDefault();chooseGift(b.dataset.giftChoice);
        });
      }
      draw();
    }
  }
  customElements.define('sakura-free-gift',GiftWidget);
  window.SakuraCartGift={reconcile};
  document.addEventListener('sakura:cart-mutated',schedule);
  document.addEventListener('sakura:cart-updated',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')schedule();});
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
  // Finish pending automatic gift changes before ordinary cart checkout. This
  // isn't a security barrier and deliberately does not alter accelerated checkout.
  document.addEventListener('click',e=>{
    const button=e.target.closest('button[name="checkout"],#CartDrawer-Checkout,a[href="/checkout"]');
    if(!button||(!running&&!dirty)||button.disabled)return;
    e.preventDefault();e.stopImmediatePropagation();
    (async()=>{await reconcile();if(dirty)await reconcile();if(!error)location.assign(root+'checkout');})();
  },true);
  schedule();
})();
